"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTORESPONDER_TYPE = void 0;
exports.AUTORESPONDER_TYPE = {
    DOUBLE_OPT_IN: 'DOUBLE_OPT_IN',
    ORDER_CANCELLATION: 'ORDER_CANCELLATION',
    ORDER_CONFIRMATION: 'ORDER_CONFIRMATION',
    ORDER_PARTIAL_REFUND: 'ORDER_PARTIAL_REFUND',
    PARTIAL_ORDER: 'PARTIAL_ORDER',
    SHIPPING_CONFIRMATION: 'SHIPPING_CONFIRMATION',
    SUBSCRIPTION_CANCELLATION: 'SUBSCRIPTION_CANCELLATION',
    WELCOME_ORDER_SMS: 'WELCOME_ORDER_SMS',
    WELCOME_ORDER_2: 'WELCOME_ORDER_2',
    SUBSCRIPTION_WELCOME: 'SUBSCRIPTION_WELCOME',
    SURVEY: 'SURVEY',
    VIP_CLUB_CONFIRMATION: 'VIP_CLUB_CONFIRMATION',
    VIP_LOGIN: 'VIP_LOGIN',
    VIP_PRE_BILLING: 'VIP_PRE_BILLING',
    VIP_PRE_BILLING_MONTHLY: 'VIP_PRE_BILLING_MONTHLY',
    VIP_CANCELLATION: 'VIP_CANCELLATION',
    PARTIAL_OPT_IN_SMS: 'PARTIAL_OPT_IN_SMS',
    // DEPRECATED VALUES
    PARTIAL_OPT: 'PARTIAL_OPT_IN',
    PARTIAL_ORDER_2: 'PARTIAL_ORDER_2'
};
//# sourceMappingURL=autoresponderType.js.map